// This icon file is generated automatically.
var PGiftOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 14 14", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M12.76 3.83h-2.3A2.15 2.15 0 007 1.26a2.15 2.15 0 00-3.44 2.57H1.26a.5.5 0 00-.5.5v3.13c0 .07.06.12.13.12h.62v5.38c0 .27.22.5.5.5h10a.5.5 0 00.5-.5V7.58h.63c.06 0 .12-.05.12-.12V4.33a.5.5 0 00-.5-.5zM7.54 2.68a1.1 1.1 0 111.1 1.09h-1.1v-1.1zm-2.16-1.1c.6 0 1.1.5 1.1 1.1v1.09h-1.1a1.1 1.1 0 010-2.19zM1.82 6.52V4.89h4.66v1.63H1.82zm.75 1.06h3.9v4.81h-3.9V7.6zm8.88 4.81h-3.9V7.6h3.9v4.8zm.75-5.87H7.54V4.89h4.66v1.63z", "fill-rule": "nonzero" } }] }, "name": "p-gift", "theme": "outlined" };
export default PGiftOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PGiftOutlined.js
// module id = 3445
// module chunks = 0